import { configureAmplify } from './amplify-config.js';
import {
  customCredentialsProvider,
  federateWithToken,
  clearFederation,
  getFederatedIdentityId
} from './credentials-provider.js';
import {
  passwordlessSignIn,
  passwordlessConfirmOTP,
  passwordlessSignUp,
  passwordlessConfirmSignUp,
  resendSignUpConfirmationCode,
  checkAmplifySession,
  resolveSocialSession,
  amplifyForgotPassword,
  amplifyConfirmForgotPassword,
  amplifySignOut
} from './auth.js';
import * as appSyncClient from './appsync-client.js';
import * as restClient from './rest-client.js';
import { addEmailToDynamoTable } from './dynamo-client.js';

// heku-amplify — Vite IIFE entry point.
// Loaded before heku-aws.js so window.hekuAmplify is ready.

// Configure Amplify immediately if heku_aws_config is already available
// (wp_localize_script on heku_amplify handle ensures this)
if (window.heku_aws_config) {
  configureAmplify();
}

// Expose helpers that heku-aws.js can call from global scope via `window.hekuAmplify.*`
export {
  configureAmplify,
  customCredentialsProvider,
  federateWithToken,
  clearFederation,
  getFederatedIdentityId,
  passwordlessSignIn,
  passwordlessConfirmOTP,
  passwordlessSignUp,
  passwordlessConfirmSignUp,
  resendSignUpConfirmationCode,
  checkAmplifySession,
  resolveSocialSession,
  appSyncClient,
  restClient,
  addEmailToDynamoTable,
  amplifyForgotPassword,
  amplifyConfirmForgotPassword,
  amplifySignOut
};
